(function ($) {
  'use strict';
  /**
   * Initialize the quiz
   */
  if ($('body').hasClass('skoda-contests')) {
    window.ys.SkodaContests = new SkodaContests();
  }
}).bind(window)(jQuery);
